<template>
  <transition name="modal-fade">
    <Modal @close="close">
      <div class="ly_pop_content ly_pop_msg ly_txt card relative">
        <div class="ly_pop_head">
          <a class="btn_ly_close svg_close" @click="close">
            <span>{{ $t('library.deletemodal.close') }}</span>
          </a>
        </div>
        <div class="ly_inner ly_txt">
          <p class="tac">책장을 삭제하시겠습니까?<br /></p>
          <div class="warningText">
            {{ $t('library.deletemodal.4895') }}
          </div>

          <div class="btn_wrap">
            <button type="submit" class="box_btn" @click="deleteBookshelf()">
              확인
            </button>
            <button type="submit" class="box_btn dull" @click="close">
              취소
            </button>
          </div>
        </div>
      </div>
    </Modal>
  </transition>
</template>
<script>
import {
  BOOKSHELF_DELETE,
  BOOKSHELF_BOOK_GET_LIST,
  BOOKSHELF_SET_CURRENT
} from '@/store/types'

export default {
  name: 'DeleteModal',
  props: {
    bookshelf: {
      type: Object,
      required: true
    }
  },
  data() {
    return {}
  },
  methods: {
    close() {
      this.$emit('close')
    },
    async deleteBookshelf() {
      const id = this.bookshelf.id
      await this.$store
        .dispatch(BOOKSHELF_DELETE, { id })
        .then((res) => {
          if (res.data.ok) {
            const def = this.$store.getters.getBookshelves.filter((e) => {
              return e.isDefault === true
            })
            this.$store.commit(BOOKSHELF_SET_CURRENT, def[0].bookshelfId)
            this.$store.dispatch(BOOKSHELF_BOOK_GET_LIST, {
              page: 1
              // sort: 'PD'
            })
          }
        })
        .catch((err) => {
          if (err) {
            this.$store.dispatch('compulsionMove', { id }).then((res) => {
              if (res.length) {
                const def = this.$store.getters.getBookshelves.filter((e) => {
                  return e.isDefault === true
                })
                this.$store
                  .dispatch('compulsionMove2', {
                    id,
                    books: res,
                    to: def[0].bookshelfId
                  })
                  .then((res) => {
                    if (res.data.ok) {
                      this.deleteBookshelf()
                    }
                  })
                  .catch((err) => console.log(err.response.data))
              }
            })
          }
        })

      // if (this.$route.params.id === id) {
      //   this.$router.push({ name: 'library_default' })
      // }

      // this.$router.go(this.$route.currentRoute)
      this.close()
    }
  }
}
</script>
<style lang="scss" scoped>
.box_btn {
  margin-left: 6px !important;
  margin-right: 6px !important;
}
.warningText {
  color: red;
  margin-top: 15px;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
}
.btn_wrap {
  display: flex;
}
.btn_wrap .box_btn {
  height: 50px;
  font-size: 16px;
  color: #fff;
}
</style>
